<section class="error-area">
  <div class="error-item">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="error-text">
                  <!-- <h3>Confirm</h3> -->
                  <p>You are about to be logged out of</p>
                  <span>trepez/{{currentUser.username}}</span>
                  <button (click)="successNotification()">Confirm</button>
              </div>
          </div>
      </div>
  </div>
</section>

